import { render, staticRenderFns } from "./PersonRow.vue?vue&type=template&id=4272719b&scoped=true&"
import script from "./PersonRow.vue?vue&type=script&lang=js&"
export * from "./PersonRow.vue?vue&type=script&lang=js&"
import style0 from "./PersonRow.vue?vue&type=style&index=0&id=4272719b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4272719b",
  null
  
)

export default component.exports